<template>
  <div class="field-textlist-edit position-relative" :class="{ 'readonly-field': calculated }">
    <!-- Botón de lock/unlock para campos safe (solo si no está deshabilitado) -->
    <div v-if="field.safe && !disableLock" class="float-left">
      <button
        v-if="isLocked"
        type="button"
        class="btn btn-sm btn-outline-secondary border-0 buttonn-lock"
        @click="unlockField"
      >
        <i class="material-icons">lock</i>
      </button>
      <button
        v-else
        type="button"
        class="btn btn-outline-primary btn-sm border-0 buttonn-lock"
        @click="lockField"
      >
        <i class="material-icons">lock_open</i>
      </button>
    </div>

    <multiselect
      :value="currentValue"
      :options="textListOptions"
      :multiple="field.isArray || false"
      :close-on-select="!field.isArray"
      :clear-on-select="true"
      :preserve-search="true"
      :preselect-first="false"
      :allow-empty="!field.required"
      :searchable="true"
      :show-labels="true"
      :disabled="field.readonly || isLocked"
      label="label"
      track-by="_id"
      :placeholder="placeholder || $t('Select an option')"
      class="mb-2"
      @input="onFieldChange"
      @blur="onBlur"
      @focus="onFocus"
    >
      <template #selection="{ option }">
        <span v-if="option">
          {{ option.label }}
          <span
            v-if="!field.isArray"
            class="multiselect__tag-icon"
            @click.stop="onRemove"
          ></span>
        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "EditFieldTextList",
  components: {
    Multiselect,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activelyEditing: false,
    };
  },
  computed: {
    textListOptions() {
      if (!this.field.options) return [];
      let optionsString = this.field.options;
      if (Array.isArray(optionsString)) {
        optionsString = optionsString[0];
      }
      const options = optionsString
        .split(/\s*[|,]\s*/)
        .map((option) => option.trim())
        .filter((option) => option);
      return options.map((option) => ({
        _id: option,
        label: this.$t(option),
      }));
    },
    currentValue: {
      get() {
        if (
          this.value !== null &&
          this.value !== undefined &&
          this.value !== ""
        ) {
          return this.formatValue(this.value);
        }
        if (
          this.field.defaultValue !== null &&
          this.field.defaultValue !== undefined &&
          this.field.defaultValue !== ""
        ) {
          return this.formatValue(this.field.defaultValue);
        }
        return null;
      },
      set(newValue) {
        this.onFieldChange(newValue);
      },
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `field-textlist-${this.field.key}`;
    },
    isLocked() {
      if (this.activelyEditing) {
        return false;
      }
      if (!this.value) {
        return false;
      }
      if (this.field.safe && this.editingFields !== this.field.key) {
        return true;
      }
      return false;
    },
  },
  methods: {
    formatValue(value) {
      if (value && typeof value === "object" && value._id && value.label) {
        return value;
      }
      if (Array.isArray(value)) {
        return value.map((item) => {
          if (typeof item === "object" && item._id) {
            return item;
          }
          return {
            _id: item,
            label: this.$t(item),
          };
        });
      }
      if (value !== null && value !== undefined && value !== "") {
        return {
          _id: value,
          label: this.$t(value),
        };
      }
      return null;
    },
    onFieldChange(newValue) {
      this.activelyEditing = true;
      let valueToEmit = newValue;
      if (Array.isArray(newValue)) {
        valueToEmit = newValue.map((item) =>
          typeof item === "object" && item._id ? item._id : item
        );
      } else if (newValue && typeof newValue === "object" && newValue._id) {
        valueToEmit = newValue._id;
      }
      this.$emit("input", valueToEmit);
    },
    onRemove() {
      this.onFieldChange(null);
    },
    onBlur() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = false;
      }
    },
    onFocus() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = true;
      }
    },
    lockField() {
      this.$emit("update:editingFields", "");
      this.activelyEditing = false;
    },
    unlockField() {
      this.$emit("update:editingFields", this.field.key);
      this.activelyEditing = true;
    },
  },
};
</script>

<style scoped>
.field-textlist-edit {
  width: 100%;
}


:deep(.multiselect-container) {
  position: relative;
  z-index: 1;
}

:deep(.multiselect.is-active) {
  z-index: 99999;
}

:deep(.multiselect__content-wrapper) {
  top: 100% !important;
  bottom: auto !important;
  transform: none !important;
  z-index: 99999 !important;
  position: absolute !important;
}

:deep(.multiselect__content) {
  max-height: 200px;
  overflow-y: auto;
}
</style>

